// /join-us — the Join landing with no module open. The page itself is rendered
// by the _landing layout (JoinLanding); this route only owns the path.
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/_landing/join-us')({
  component: () => null,
});
